export default "__VITE_ASSET__Cd9bpE$1__"